<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 1c-3 0-5 2-5 5 0 4 5 9 5 9s5-5 5-9c0-3-2-5-5-5z M10 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      stroke="currentColor"
      stroke-width="1.3"
      fill="none"
    />
  </svg>
</template>
